import publicConfig from "../public-config.js";

import { request as httpRequest } from "./http-library.js";

const ssoHost = publicConfig.external_address;

const Payouts = {
  read: function read(ssoId, token, query, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/payments/users/${ssoId}/payouts${query ? `${query}` : ""}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    httpRequest(requestParams, function request(response) {
      callback(response);
    });
  },
};

export default Payouts;
